// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2xAww","label":"Labeled_label__1toPO","divider":"Labeled_divider__1XZSL"};